import { v4 as createGuid } from "uuid";
import { IVueDawnLogsRequest } from "./api/unifiedPortal/interfaces";
import { FLAGS, SiteVersion } from "@/define";
import { unifiedApi } from ".";
import { useBuyFlowStore } from "@/stores/buyFlow";
import { useBuyFlowManagerStore } from "@/stores/buyFlowManager";

//Simple method used to track what methods are being called so we can figure out where users are having issues
export async function addBuyFlowLogEntry(message: string) {
  const buyFlowStore = useBuyFlowStore();
  const buyFlowManagerStore = useBuyFlowManagerStore();
  const request = { vueDawnVersion: SiteVersion, message: message } as IVueDawnLogsRequest;
  try {
    //Check/Create transaction GUID
    let transactionGuid = sessionStorage.getItem("transactionGuid") || "";
    if (!transactionGuid) {
      transactionGuid = createGuid();
      sessionStorage.setItem("transactionGuid", transactionGuid);
    }

    request.transactionGuid = transactionGuid;

    //Check for userGuid
    request.userGuid = buyFlowStore?.cart?.userGuid ?? buyFlowManagerStore.userGuid ?? null;

    //Check for order code
    request.orderCode = buyFlowStore?.cart?.orderCode ?? buyFlowManagerStore.orderCode ?? null;

    await unifiedApi.addVueDawnLog(request);
  } catch {
    //Do nothing. This call failing should not impact the buy flow
  }

  if (FLAGS.IS_DEBUG) {
    console.log(request);
  }
}
